import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActiveCartService, getCartIdByUserId, MultiCartService } from '@spartacus/cart/base/core';
import { Cart, OrderEntry } from '@spartacus/cart/base/root';
import { WishListService } from '@spartacus/cart/wish-list/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  OCC_CART_ID_CURRENT,
  User,
  UserIdService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { filter, tap, withLatestFrom } from 'rxjs/operators';
import { UigCartService } from '../uig-cart.service';

@Component({
    selector: 'app-uig-wishlist',
    templateUrl: './uig-wishlist.component.html',
    styleUrls: ['./uig-wishlist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigWishlistComponent implements OnInit, OnDestroy {
  @ViewChild('wishlistProductsForm') wishlistProductsForm: NgForm;
  wishList$: Observable<Cart>;
  addFromWishlist$: Observable<Object>;
  entries: OrderEntry[];

  subscription: Subscription;

  numberOfEntries: number;
  loading: boolean;
  disableButton = true;
  isRestricted = false;
  RIO_CART_ORDER = 'rio_cart_order';
  RIO_CART_CREATE_UPDATE = 'rio_cart_create_update';
  roles: string[];
  private userSubscription = new Subscription();
  SHOW_MSG_TIMEOUT_CONFIRMATION = 600000;

  constructor(
    private wishListService: WishListService,
    private uigCartService: UigCartService,
    private multiCartService: MultiCartService,
    private activeCartService: ActiveCartService,
    private messageService: GlobalMessageService,
    private userIdService: UserIdService,
    private userAccountFacade: UserAccountFacade
  ) { }

  ngOnInit(): void {
    this.wishList$ = this.wishListService.getWishList();

    this.wishList$
      .pipe(
        filter((wishlist) => wishlist != null),
        tap((wishlist) => {
          this.entries = wishlist.entries;
          this.numberOfEntries = wishlist.entries.length;
        })
      )
      .subscribe();
    this.checkForRoles();
  }

  onSubmit(): void {
    const productCodes = new Array<String>();
    for (let i = 0; i < this.numberOfEntries; i++) {
      if (this.wishlistProductsForm.controls[i].value == true) {
        productCodes.push(this.entries[i].product.code);
      }
    }

    this.activeCartService
      .requireLoadedCart()
      .pipe(withLatestFrom(this.userIdService.getUserId()))
      .subscribe(([cartState, userId]) => {
        this.addFromWishlist$ = this.uigCartService.addFromWishlist(
          productCodes.join(','),
          getCartIdByUserId(cartState, userId)
        );
        this.addFromWishlist$
          .pipe(
            tap((errorMessages) => {
              this.showErrorMessages(errorMessages);
            })
          )
          .subscribe((_res) => {
            this.multiCartService.reloadCart(OCC_CART_ID_CURRENT);
            this.wishlistProductsForm.resetForm();
          });
      });
  }

  showErrorMessages(errorMessages: any) {
    for (const errorMessage of errorMessages as string[]) {
      this.messageService.add(errorMessage, GlobalMessageType.MSG_TYPE_ERROR, this.SHOW_MSG_TIMEOUT_CONFIRMATION);
    }
  }

  handleWishlistButton() {
    let enable = false;
    if (this.wishlistProductsForm) {
      for (let i = 0; i < this.numberOfEntries; i++) {
        if (this.wishlistProductsForm.controls[i].value == true) {
          enable = true;
          break;
        }
      }
    }
    this.disableButton = !enable;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.userSubscription.unsubscribe();
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
